<template>
  <div v-r-loading.fullscreen="pageLoading" class="store">
    <StoreSkeleton v-if="!isInit" />
    <div v-if="isLoadStore">
      <!-- 强提醒 -->
      <StrongTips v-if="alertInfo" :content="alertInfo.content" />
      <!-- ShopTopInfo -->
      <ShopTopInfoV2 :is-store-font="isStoreFont" />
      <!-- 导航&信息 -->
      <ScrollNav :pc-top="alertInfo ? '120px' : '60px'" :items="cateInfo" />
      <MiniCart
        v-if="isInit"
        ref="minicart"
        :is-close="isClose"
        :cart-data="cartData"
        @card-item="cardItemClick"
      />
      <!-- SF天降红包 -->
      <GrowthDialog
        :data="popDialogData"
        :is-store-font="isStoreFont"
        :shop-id="shopId"
        @handleClose="handleCloseGrowth"
      />
      <!-- SF未登录遮罩 -->
      <SfHide v-if="!isLogin" />
    </div>
    <template v-if="isInit && isGrocery">
      <EmptyState empty-type="noGrocery" @tryAgain="initData"></EmptyState>
    </template>
    <template v-if="isInit && isStoreFont && !isStoreFontOpen">
      <EmptyState
        empty-type="noStoreFont"
        :empty-title="shopInfo?.promotionChannelActiveStatusDesc?.title"
        :empty-desc="shopInfo?.promotionChannelActiveStatusDesc?.content"
      ></EmptyState>
    </template>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import GrowthDialog from '@/components/GrowthDialog'
import ShopTopInfoV2 from '@/components/ShopTopInfo/indexV2.vue'
import StoreSkeleton from '@/components/SkeletonComponents/storeSkeleton/storeSkeleton'
import ScrollNav from '@/components/ScrollNav'
import SfHide from '@/components/SfHide'
import MiniCart from '@/components/MiniCart/index.vue'
import StrongTips from '@/components/ShopTopInfo/strongTips.vue'
import { isBusinessError } from '@/lib/request/index'
import strategyLog, { TYPE_MAP } from '@/config/trackLog/StrategyLog'
import { CATE_SOURCE } from '@/const/dishfood'
import { addTitlePrefixToStore } from '@/utils/baseUtil'
import EmptyState from '@/components/EmptyState'
import { getLocalStorage } from '@/utils/localStorage'
import storeFont from '@/utils/storefont'

export default {
  name: 'Store',
  components: {
    ShopTopInfoV2,
    ScrollNav,
    StoreSkeleton,
    MiniCart,
    StrongTips,
    EmptyState,
    GrowthDialog,
    SfHide,
  },
  beforeRouteEnter(to, from, next) {
    const trueSourceRouteName = ['feed', 'search', 'bill']
    if (!trueSourceRouteName.includes(from?.name)) {
      // 重置策略埋点数据
      strategyLog.setStrategyData(TYPE_MAP.LV1_INFO, {
        lv1_location: '',
        lv1_recid: '',
      })
    }
    next()
  },
  data() {
    return {
      pageLoading: false,
      isInit: false,
      showDish: false,
      isGrocery: false,
      dialogVisible: true,
      itemId: this.$route.params.itemId,
      shopId: this.$route.params.storeId,
      mouseHoverMiniCart: false,
    }
  },
  computed: {
    ...mapState({
      shopInfo: ({ store }) => store.shopInfo,
      shopHeader: ({ store }) => store.shopHeader,
      cateInfo: ({ store }) => store.cateInfo,
      cartData: ({ cart }) => cart.cartInfo,
      alertInfo: ({ store }) => store.alertInfo,
      popDialogData: ({ store }) => store.popDialogData,
      isH5: ({ common }) => common.isH5,
      popData: ({ act }) => act.popData,
    }),
    isClose() {
      return this.shopInfo.cShopStatus !== 1
    },
    isStoreFont() {
      return storeFont.isStoreFont()
    },
    isLogin() {
      return getLocalStorage('isLogin')
    },
    isLoadStore() {
      // return this.isInit;
      if (this.isStoreFont) {
        return this.isInit && this.isStoreFontOpen
      } else {
        return this.isInit && !this.isGrocery
      }
    },
    isStoreFontOpen() {
      return this.isStoreFont && this.shopInfo?.promotionChannelActiveStatus === 1
    },
    isShopNoPromotion() {
      if (this.isStoreFont && this.isLogin) {
        return (
          !this.shopHeader?.tags?.length &&
          !this.shopHeader?.couponTags?.length &&
          !this.popDialogData?.needPopup
        )
      } else {
        return false
      }
    },
  },
  watch: {
    shopInfo(nVal) {
      if (nVal?.shopName) {
        document.title = addTitlePrefixToStore(nVal.shopName)
      }
    },
    isInit(nVal, oVal) {
      if (nVal !== oVal && nVal) {
        this.$nextTick(() => {
          this.bindHover()
        })
      }
    },
  },
  async mounted() {
    this.isInit = false
    this.getInit()
  },
  methods: {
    ...mapActions('store', ['shopIndex', 'itemDetail', 'addItem']),
    ...mapActions('cart', ['addOrUpdateItem', 'cartInfo', 'reduceAmountToZero']),
    async getInit() {
      const res = await this.shopIndex({
        shopId: this.$route.params.storeId,
      })
      // 产品要求的特殊逻辑 所以这里把catch的信息也拿过来进行判断；在找不到这个店铺的信息时跳转到首页
      if (res && Object.prototype.hasOwnProperty.call(res, 'errno')) {
        ;+res.errno === 42500 && this.$router.replace('/feed')
        // 商超适配
        if (+res.errno === 42511) {
          this.isInit = true
          this.isGrocery = true
          return
        }
        if (+res.errno !== 0) return
      }
      await this.cartInfo({
        shopId: this.$route.params.storeId,
      })
      this.isInit = true
      this.itemId && this.findItem()

      this.$on('on-select-goods-btn', this.eventSelectGoodsBtn)
      this.$on('on-select-goods-box', this.eventSelectGoodsBox)
      this.bindScroll()

      this.getShopCommonSw()
      this.$utils.googleGTM('sailing_c_x_shop_common_sw')
      this.getShopNoPromotion()
    },
    // SF渠道关闭弹窗刷新
    handleCloseGrowth() {
      this.getInit()
    },
    // SF券被领完情况
    getShopNoPromotion() {
      if (this.isShopNoPromotion && this.isStoreFontOpen) {
        this.$utils.infoToast(this.$t('FoodC_Storefront_bIgB_uLGp'))
      }
    },
    async initData() {
      this.$router.go(-1)
    },
    getShopCommonSw() {
      this.$trackEvent(this.sailing_c_x_shop_common_sw())
      // SF渠道需要曝光两次，一次forDAU统计
      this.$trackEvent(this.sailing_c_x_shop_common_sw(true))
    },
    // 页面曝光埋点
    sailing_c_x_shop_common_sw(isDAU) {
      const {
        shopId,
        cShopStatus = 1,
        currency,
        distance,
        deliveryPriceOri,
        deliveryPriceAct,
        deliveryTime,
        deliveryType,
      } = this.shopInfo
      const data = {
        eventId: this.isStoreFont
          ? isDAU
            ? 'sailing_c_x_startpage_startup_app_sw'
            : 'sailing_c_x_outside_shop_sw'
          : 'sailing_c_x_shop_common_sw',
        eventLabel: this.isStoreFont
          ? isDAU
            ? '每次Storefront渠道的Web商家页刷新时上报'
            : 'Web商家页实际曝光'
          : '进入店铺时页面曝光',
        attrs: {
          shop_id: shopId,
          shop_status: cShopStatus,
          delivery_fee: `${currency}_${deliveryPriceOri}_${deliveryPriceAct}`,
          delivery_distance: distance,
          delivery_time: deliveryTime,
          delivery_type: deliveryType,
          url: window.location.href,
        },
      }

      return data
    },
    /** @desc 获取天降红包数据 */
    // async getGrowthPop() {
    //   const obj = { position: 10 }; // SF 渠道为10
    //   const afterLogin = getSessionStorage('afterLogin') || '';
    //   if (afterLogin) {
    //     delSessionStorage('afterLogin');
    //     await this.getActPopFun(obj);
    //   }
    // },
    /** @desc 点击菜品添加按钮 */
    eventSelectGoodsBtn(data, payload = {}, logInfo) {
      if (
        data.cHasWine === 1 ||
        (data.contentList && data.contentList.length) ||
        +this?.shopInfo?.needReloadSubitem === 1
      ) {
        // 有规格菜品&酒类菜品
        this.eventSelectGoodsBox(data, payload)
        return
      }
      // 限制逻辑
      if (this.$refs?.minicart?.amountSum >= 15) {
        this.$utils.warningToast(this.$t('抱歉，您最多可加购15个菜品'))
        return
      }

      // 加购 逻辑
      const nodeList = [data.node]
      nodeList[0].amount = 1
      this.addShoppingCart({ nodeList, openDrawer: false })

      // 单规格加购埋点
      try {
        const CK_DATA = this.$utils.cloneDeep(logInfo)
        CK_DATA.eventId = 'sailing_c_x_shop_item2cart_ck'
        CK_DATA.eventLabel = '单规格点击加购'
        CK_DATA.attrs = {
          ...CK_DATA.attrs,
          copy_num: 1,
        }
        this.$trackEvent(CK_DATA)
        this.$utils.googleGTM('sailing_c_x_shop_item2cart_ck')
      } catch (err) {
        console.log('单规格加购埋点：' + err)
      }
    },
    /** @desc 点击菜品卡片 */
    async eventSelectGoodsBox(data, payload = {}) {
      let dishFoodInfo = null
      if (+this?.shopInfo?.needReloadSubitem === 1) {
        this.pageLoading = true
        dishFoodInfo = await this.itemDetail({
          shopId: data.shopId,
          itemId: data.itemId,
        })
        this.pageLoading = false
        if (!dishFoodInfo) {
          this.$utils.errorToast(this.$t('请重试'))
          return
        }
      } else {
        dishFoodInfo = data
      }
      this.showDish = true
      // 唤起规格页
      const dishInstance = this.$dishFood({
        source: CATE_SOURCE.STORE.name,
        disabled: this.isClose,
        cateItemNum: this.$refs?.minicart?.amountSum,
        info: dishFoodInfo,
      })
        .updateCartHook(data => {
          this.addShoppingCart({ nodeList: data, openDrawer: true }, dishInstance, {
            item: dishFoodInfo,
            payload: {
              from: 1,
              copy_num: data[0].amount,
            },
          })
        })
        .closeHook(() => {
          this.clearItemUrl(dishFoodInfo)
        })
      this.itemToUrl(dishFoodInfo)
      this.getSailing_c_x_specselection_common_sw(dishFoodInfo, {
        ...payload,
        from: 1,
      })
    },
    // 购物车唤起 规格
    async cardItemClick(data) {
      this.pageLoading = true
      const { shopId } = this.shopInfo
      const mduId = data.mduId
      const detail = await this.itemDetail({
        shopId,
        itemId: data.itemId,
        mduId,
        cartId: data.cartId,
      })
      this.pageLoading = false
      if (!detail) {
        this.$utils.errorToast(this.$t('请重试'))
        return
      }
      const dishInstance = this.$dishFood({
        source: CATE_SOURCE.CART.name,
        disabled: this.isClose,
        cateItemNum: this.$refs?.minicart?.amountSum - detail.amount,
        info: detail,
      }).updateCartHook(async data => {
        // 编辑时，将数量减至零
        if (this._hasReduceAmountToZero(data)) {
          this._openLoading(dishInstance)
          await this.reduceAmountToZero(this._getTopLevelNode(data))
          this._closeLoading(dishInstance)
          dishInstance?.onClose()
          this.getSailing_c_x_specselection_item2cart_ck(detail, {
            from: 3,
            copy_num: 0,
          })
        } else {
          await this.addShoppingCart({ nodeList: data, mduId, openDrawer: true }, dishInstance, {
            item: detail,
            payload: {
              from: 3,
              copy_num: data[0].amount,
            },
          })
        }
      })
      this.getSailing_c_x_specselection_common_sw(detail, {
        position: '',
        cateId: '',
        cateIndex: '',
        from: 3,
      })
    },
    _openLoading(dishInstance) {
      dishInstance?.onShowLoading()
      !dishInstance && (this.pageLoading = true)
    },
    _closeLoading(dishInstance) {
      dishInstance?.onCloseLoading()
      !dishInstance && (this.pageLoading = false)
    },
    _hasReduceAmountToZero(list) {
      let hasReduceToZero = false
      list.forEach(item => {
        if (item.level === 1 && item.amount === 0) {
          hasReduceToZero = true
        }
      })
      return hasReduceToZero
    },
    _getTopLevelNode(list) {
      // TODO 简单规格页编辑，数量改为0时，返回数据格式不同，存在多个level为1的节点；预期只有一个
      let node = null
      list.forEach(item => {
        if (item.level === 1 && item.amount === 0) {
          node = item
        }
      })
      return node
    },
    async addShoppingCart(params, dishInstance, payload) {
      dishInstance?.onShowLoading()
      !dishInstance && (this.pageLoading = true)
      const res = await this.addItem(params)
      if (isBusinessError(res)) {
        this.pageLoading = false
        dishInstance?.onCloseLoading()
        this.$utils.errorToast(res.errmsg || this.$t('请重试'))
      } else {
        this.pageLoading = false
        dishInstance?.onClose()
        if (!this.isH5 && params?.openDrawer && this.$refs?.minicart?.setDrawer) {
          this.$nextTick(() => {
            this.bindHover()
          })
          this.$refs.minicart.setDrawer(true)
        }
        payload && this.getSailing_c_x_specselection_item2cart_ck(payload.item, payload.payload)
      }
      !dishInstance && (this.pageLoading = false)
    },
    // url 唤起 规格
    findItem() {
      // 初始化时 url 获取itemId 并唤起规格页
      let itemInfo = null
      let cateId = ''
      let cateIndex = 0
      let position = 0
      this.cateInfo.find((item, index) => {
        // eslint-disable-next-line array-callback-return
        const info = item?.items.find((info, index) => {
          if (this.itemId === String(info.itemId)) {
            position = index
            return true
          }
        })
        if (info) {
          itemInfo = info
          cateIndex = index
          cateId = item.cateId
        }
        return !!info
      })
      itemInfo &&
        this.eventSelectGoodsBox(itemInfo, {
          position,
          cateId,
          cateIndex,
          from: 1,
        })
    },
    itemToUrl(item) {
      // 打开规格变更url
      this.$router
        .replace({
          path: `/store/${item?.shopId}/${this.shopInfo?.shopName}/${item?.itemId}/${item?.itemName}`,
          query: this.$route.query,
        })
        .catch(() => {})
    },
    clearItemUrl(item) {
      // 清理 规格路由
      const itemId = this.$route.params.itemId
      if (itemId) {
        this.$router
          .replace({
            path: `/store/${item?.shopId}/${this.shopInfo?.shopName}`,
            query: this.$route.query,
          })
          .catch(() => {})
      }
    },
    // 绑定滚动事件
    bindScroll() {
      document.addEventListener('scroll', this.onScroll)
    },
    onScroll() {
      if (!this.isH5 && !this.mouseHoverMiniCart && this.$refs?.minicart?.getDrawer()) {
        this.$refs.minicart.setDrawer(false)
      }
    },
    // 绑定hover 相关事件 用来区别是在minicart滚动还是在页面滚动 判断收起 drawer
    bindHover() {
      if (this.isH5) return
      if (!this.$refs?.minicart?.showMiniCart) return
      this.removeBindHover()
      const dom = this.$refs?.minicart?.$el
      dom && dom.addEventListener('mouseover', this.onmouseover)
      dom && dom.addEventListener('mouseout', this.onmouseout)
    },
    removeBindHover() {
      const dom = this.$refs?.minicart?.$el
      dom && dom.removeEventListener('mouseover', this.onmouseover)
      dom && dom.removeEventListener('mouseout', this.onmouseout)
      this.mouseHoverMiniCart = false
    },
    onmouseover(e) {
      const dom = this.$refs?.minicart?.$el
      const mask = dom?.querySelector('.mask-opacity-box')
      if (e?.target === mask) return
      this.mouseHoverMiniCart = true
    },
    onmouseout(e) {
      const dom = this.$refs?.minicart?.$el
      const mask = dom?.querySelector('.mask-opacity-box')
      if (e?.target === mask) return
      this.mouseHoverMiniCart = false
    },
    getSailing_c_x_specselection_common_sw(item, payload) {
      const { shopId, cShopStatus = 1 } = this.shopInfo
      const data = {
        eventId: 'sailing_c_x_specselection_common_sw',
        eventLabel: '进入规格选择页的页面展示',
        attrs: {
          shop_id: shopId,
          shop_status: cShopStatus,
          item_id: item.itemId,
          item_status: +item.status === 1 ? 1 : 2,
          item_position: payload.position,
          sold_status: item.soldStatus,
          mutiply_level: item?.node?.totalLevel,
          has_multi_content: item?.contentList?.length ? 1 : 0,
          tab_id: payload.cateId,
          tab_position: payload.cateIndex,
          from: payload.from, // 1 商家页 3 mini 购物车(购物车改版添加) 4 提单页
        },
      }
      this.$trackEvent(data)
    },
    getSailing_c_x_specselection_item2cart_ck(item, payload) {
      // 规格加购更新成功后的埋点
      const { shopId, cShopStatus = 1 } = this.shopInfo
      const data = {
        eventId: 'sailing_c_x_specselection_item2cart_ck',
        eventLabel: '规格选择页面点击加购结果',
        attrs: {
          shop_id: shopId,
          shop_status: cShopStatus,
          item_id: item.itemId,
          item_status: +item.status === 1 ? 1 : 2,
          sold_status: item.soldStatus,
          limited_time: item.soldTimeDesc || '',
          has_multi_content: item?.contentList?.length ? 1 : 0, // 0. 单规格 1. 多规格
          if_mutiply_level: +(item?.node?.totalLevel > 2),
          from: payload.from, // 1 商家页 3 mini 购物车(购物车改版添加) 4 提单页
          cart_id: this.cartData.cartId || '',
          copy_num: payload.copy_num,
        },
      }
      this.$trackEvent(data)
      this.$utils.googleGTM('sailing_c_x_specselection_item2cart_ck')
    },
  },
  // eslint-disable-next-line vue/order-in-components
  destroyed() {
    document.removeEventListener('scroll', this.onScroll)
    this.removeBindHover()
  },
}
</script>

<style scoped lang="scss">
.store {
  padding-bottom: 100px;
}
</style>
